export default {
  common: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/layouts/common.vue").then(m => m.default || m),
  "default-no-header": () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/layouts/default-no-header.vue").then(m => m.default || m),
  default: () => import("/data/teamcity/work/f6010d7a8f2d88ad/applications/smart-application/layouts/default.vue").then(m => m.default || m)
}